import { LogLevel } from "angular-auth-oidc-client";

export const endpoints = {
    // CONTACT
    users: '/users/:buildingId', // get all users of a building
    userInfo: '/user_info', // get user info by token
    getUserPermissions: '/user_permissions', // get user permissions for buildingId

    //STUDENT
    findStudentBySsid: '/find_student_by_student_identifier/region/:regionId', // find student by ssid
    createStudent: '/create_student_record/region/:regionId', // create student & create new case for that student
    updateStudent: '/update_student/region/:regionId', // update student

    // CASE
    getAllAssessCasesByStudentID: '/find_assess_cases_by_student_identifier', // get all cases of a student (POST)
    getAllAssessCasesByBuildingID: '/assess_cases_by_building_id/:buildingId', // get all cases of a building
    getAssessCaseByCaseId: '/assess_cases_by_case_id/:caseId', // get case by case id
    createNewCaseForExistingStudent: '/create_assess_case', // create new case for existing student
    completeUploadedCase: '/complete_uploaded_case', // answer the full team question and close an uploaded case

    // HISTORY
    getHistoryByCaseId: '/record_of_changes/case/:caseId', // get history by case id

    // USER TASKS
    getUserTasks: '/user_tasks/building/:buildingId', // get user tasks, building id is required, user_id will be taken from token

    // THREAT ASSESSMENT TEAM
    getThreatAssessmentTeam: '/get_threat_assessment_team/:caseId', // get threat assessment team by case id
    updateThreatAssessmentTeam: '/create_threat_assessment_team', // update threat assessment team

    // REVIEW REQUEST
    requestReview: '/create_section_reviews', // request review
    cancelReviewRequest: '/cancel_review_request', // cancel review request
    reviewApprove: '/section_reviews_approve', // review complete

    // BEHAVIORAL SCREEN
    getAssessScreenByCaseId: '/behavioral_assessment_screen_by_case_id/:caseId', // get assessment screen by case id
    updateAssessScreen: '/update_behavioral_assessment_screen', // update assessment screen

    // FULL TEAM THREAT ASSESSMENT
    getFullTeamAssessmentByCaseId: '/full_team_threat_assessment_by_case_id/:caseId', // get full team assessment by case id
    updateFullTeamAssessment: '/update_full_team_threat_assessment', // update full team assessment

    // TEACHER STAFF INTERVIEW
    getTeachStaffInterviewByCaseId: '/teacher_staff_interview_by_case_id/:caseId', // get teacher staff interview by case id
    updateTeachStaffInterview: '/update_teacher_staff_interview', // update teacher staff interview

    // WITNESS INTERVIEW
    getWitnessInterviewByCaseId: '/witness_interview_by_case_id/:caseId', // get witness interview by case id
    updateWitnessInterview: '/update_witness_interview', // update witness interview

    // STUDENT OF CONCERN INTERVIEW
    getStudentOfConcernInterviewByCaseId: '/student_of_concern_interview_by_case_id/:caseId', // get student of concern interview by case id
    updateStudentOfConcernInterview: '/update_student_of_concern_interview', // update student of concern interview

    // PARENT INTERVIEW
    getParentInterviewByCaseId: '/parent_interview_by_case_id/:caseId', // get parent interview by case id
    updateParentInterview: '/update_parent_interview', // update parent interview

    // RMS PLAN CHECKLIST
    getRMSPlanChecklistByCaseId: '/rms_plan_checklist_by_case_id/:caseId', // get rms plan checklist by case id
    updateRMSPlanChecklist: '/update_rms_plan_checklist', // update rms plan checklist

    // ROAR ASSIGNMENT FORM
    getRoarAssignmentFormByRoarId: '/roar_assignment_form_by_roar_id/:roarId', // get roar assignment form by roar id
    getRoarAssignmentFormByCaseId: '/roar_assignment_form_by_case_id/:caseId', // get roar assignment form by case id
    getCompletedRoarAssignmentFormByCaseId: '/completed_roar_assignment_form_by_case_id/:caseId', // get completed roar assignment form by case id
    createRoarAssignmentForm: '/create_roar_assignment_form', // create roar assignment form
    updateRoarAssignmentForm: '/update_roar_assignment_form', // update roar assignment form
    updateRoarActivity: '/update_roar_activity', // update roar activity
    updateRoarReview: '/update_roar_review', // update roar review

    // RMS PLAN REVIEW SCHEDULE
    getRMSPlanReviewScheduleByCaseId: '/rms_plan_review_schedule_by_case_id/:caseId', // get rms plan review schedule by case id
    updateRMSPlanReviewSchedule: '/update_rms_plan_review_schedule', // update rms plan review schedule

    // RMS PLAN SUMMARY
    getRMSPlanSummaryByCaseId: '/rms_plan_summary_by_case_id/:caseId', // get rms plan summary by case id
    updateRMSPlanSummary: '/update_rms_plan_summary', // update rms plan summary

    // THREAT ASSESSMENT SUMMARY
    getThreatAssessmentSummaryByCaseId: '/threat_assessment_summary_by_case_id/:caseId', // get threat assessment summary by case id
    updateThreatAssessmentSummary: '/update_threat_assessment_summary', // update threat assessment summary

    // RMS RECORD REVIEW
    getRMSRecordReviewByCaseId: '/rms_record_review_by_case_id/:caseId', // get rms record review by case id
    updateRMSRecordReview: '/update_rms_record_review', // update rms record review

    // CASE CLOSING
    getCaseClosingSummaryByCaseId: '/case_closing_summary_by_case_id/:caseId', // get case closing by case id
    updateCaseClosingSummary: '/update_case_closing_summary', // update case closing

    // DOWNLOAD FILES
    downloadFile: '/pdf/:form_name/:caseId', // download files

    // CASE FILES
    uploadCaseFiles: '/upload_case_files/case/:caseId', // upload files for an uploaded case (multipart)
    getCaseFiles: '/case_files/case/:caseId', // list uploaded files of a case
    downloadCaseFile: '/download_case_file/case/:caseId/file/:fileId', // get a signed url for an uploaded file

    // GET TIPS FOR A BUILDING
    getTipsForBuilding: '/tipsDash/API/getTipsForBuilding/:buildingId', // get tips for a building

    // GET TIPS-ASSESS RELATIONSHIP FOR A CASE
    findTipsAssessRelationship: '/find_tips_assess_relationship/:buildingId/:caseId', // check if tips-assess relationship exists for a case
    updateTipsAssessRel: '/update_tips_assess_rel', // update tips-assess relationship for a case
};
  